export default "__VITE_ASSET__gntNX9LD__"